import { render } from "./TreatmentCardInput.vue?vue&type=template&id=23583e55"
import script from "./TreatmentCardInput.vue?vue&type=script&lang=js"
export * from "./TreatmentCardInput.vue?vue&type=script&lang=js"
script.render = render

export default script